/* Brand motion: native browser animation, lifecycle-aware playback, no telemetry. */
(function () {
  'use strict';
  function createPlayback(options) {
    var count = options.count;
    var schedule = options.schedule || setTimeout;
    var cancel = options.cancel || clearTimeout;
    var delay = options.delay || 7000;
    var index = 0;
    var timer = null;
    var destroyed = false;
    var state = { userPaused: false, reduced: !!options.reduced, visible: options.visible !== false, documentVisible: true, held: false, blocked: false };
    function running() { return !destroyed && count > 1 && !state.userPaused && !state.reduced && state.visible && state.documentVisible && !state.held && !state.blocked; }
    function sync() {
      if (timer !== null) { cancel(timer); timer = null; }
      var play = running();
      if (options.onState) options.onState({ running: play, userPaused: state.userPaused, reduced: state.reduced, index: index });
      if (play) timer = schedule(function () {
        timer = null;
        if (!running()) return;
        index = (index + 1) % count;
        options.onSelect(index, 'auto');
        sync();
      }, delay);
    }
    function set(key, value) { value = !!value; if (state[key] === value) return; state[key] = value; sync(); }
    var api = {
      select: function (next) {
        if (destroyed || !Number.isInteger(next) || next < 0 || next >= count) return;
        state.userPaused = true;
        index = next;
        options.onSelect(index, 'manual');
        sync();
      },
      toggle: function () { if (!destroyed) set('userPaused', !state.userPaused); },
      setVisible: function (value) { set('visible', value); },
      setDocumentVisible: function (value) { set('documentVisible', value); },
      setHeld: function (value) { set('held', value); },
      setReduced: function (value) { set('reduced', value); },
      setBlocked: function (value) { set('blocked', value); },
      getState: function () { return { index: index, running: running(), userPaused: state.userPaused, reduced: state.reduced, destroyed: destroyed }; },
      destroy: function () { destroyed = true; sync(); }
    };
    if (count > 0) options.onSelect(0, 'initial');
    sync();
    return api;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createPlayback: createPlayback };
  if (typeof document === 'undefined') return;
  if (window.OpenXBrandMotion) { window.OpenXBrandMotion.init(document); return; }
  var cleanups = new WeakMap();
  function init(scope) {
    var roots = scope.matches && scope.matches('[data-brand-home]') ? [scope] : scope.querySelectorAll('[data-brand-home]');
    roots.forEach(function (root) {
      if (cleanups.has(root)) return;
      var cleanup = [];
      var media = window.matchMedia('(prefers-reduced-motion: reduce)');
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      var hero = root.querySelector('[data-brand-hero]');
      var scenes = Array.from(root.querySelectorAll('[data-brand-scene]'));
      var tabs = Array.from(root.querySelectorAll('[data-scene-select]'));
      var controls = root.querySelector('[data-scene-controls]');
      var pause = root.querySelector('[data-scene-pause]');
      var sceneLabel = root.querySelector('[data-scene-label]');
      var sceneLink = root.querySelector('[data-scene-link]');
      var status = root.querySelector('[data-scene-status]');
      var pans = new Map();
      var playback;
      var heldByPointer = false;
      var heldByFocus = false;
      function listen(target, name, fn, options) {
        target.addEventListener(name, fn, options);
        cleanup.push(function () { target.removeEventListener(name, fn, options); });
      }
      function pan(index) {
        var img = scenes[index].querySelector('img');
        if (pans.has(index)) pans.get(index).cancel();
        if (media.matches || !img.animate) return;
        pans.set(index, img.animate([
          { transform: 'scale(1.025) translateX(0)' },
          { transform: 'scale(1.095) translateX(-.8%)' }
        ], { duration: 8200, easing: 'linear', fill: 'both' }));
      }
      function select(index, reason) {
        scenes.forEach(function (scene, i) {
          scene.classList.toggle('is-active', i === index);
          scene.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          if (pans.has(i)) pans.get(i).pause();
        });
        tabs.forEach(function (tab, i) { tab.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
        sceneLabel.textContent = scenes[index].dataset.sceneTitle;
        sceneLink.href = scenes[index].dataset.sceneUrl;
        sceneLink.setAttribute('aria-label', 'Explore ' + scenes[index].dataset.sceneTitle.toLowerCase());
        root.dataset.activeScene = String(index);
        pan(index);
        if (reason === 'manual') status.textContent = scenes[index].dataset.sceneTitle;
      }
      if (hero && scenes.length && tabs.length === scenes.length && pause) {
        playback = createPlayback({ count: scenes.length, reduced: media.matches, visible: false,
          onSelect: select,
          onState: function (s) {
            root.dataset.motionRunning = String(s.running);
            root.dataset.reducedMotion = String(s.reduced);
            pause.setAttribute('aria-pressed', String(s.userPaused));
            pause.setAttribute('aria-label', s.userPaused ? 'Play slideshow' : 'Pause slideshow');
            pause.querySelector('[data-pause-label]').textContent = s.userPaused ? 'Play' : 'Pause';
            pause.classList.toggle('is-paused', s.userPaused);
            if (pans.has(s.index)) { if (s.running) pans.get(s.index).play(); else pans.get(s.index).pause(); }
          }
        });
        controls.hidden = false;
        tabs.forEach(function (tab, i) { listen(tab, 'click', function () { playback.select(i); }); });
        listen(pause, 'click', function () {
          if (playback.getState().userPaused) { heldByPointer = false; heldByFocus = false; playback.setHeld(false); }
          playback.toggle();
        });
        listen(controls, 'pointerenter', function () { if (finePointer.matches) { heldByPointer = true; playback.setHeld(heldByPointer || heldByFocus); } });
        listen(controls, 'pointerleave', function () { heldByPointer = false; playback.setHeld(heldByFocus); });
        listen(controls, 'focusin', function () { heldByFocus = true; playback.setHeld(true); });
        listen(controls, 'focusout', function (event) { if (!controls.contains(event.relatedTarget)) { heldByFocus = false; playback.setHeld(heldByPointer); } });
        listen(document, 'visibilitychange', function () { playback.setDocumentVisible(!document.hidden); });
        playback.setDocumentVisible(!document.hidden);
        listen(document, 'toggle', function (event) {
          if (event.target.matches && event.target.matches('.oxp-search-disclosure')) playback.setBlocked(event.target.open);
        }, true);
        playback.setBlocked(!!document.querySelector('.oxp-search-disclosure[open]'));
        if ('IntersectionObserver' in window) {
          var heroObserver = new IntersectionObserver(function (entries) { playback.setVisible(entries[0].isIntersecting); }, { threshold: .1 });
          heroObserver.observe(hero); cleanup.push(function () { heroObserver.disconnect(); });
        } else playback.setVisible(true);
        cleanup.push(function () { playback.destroy(); pans.forEach(function (a) { a.cancel(); }); });
      }
      var story = root.querySelector('[data-brand-story]');
      if (story) {
        var steps = Array.from(story.querySelectorAll('[data-story-step]'));
        var arts = Array.from(story.querySelectorAll('[data-story-art]'));
        if ('IntersectionObserver' in window) {
          var storyObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var index = steps.indexOf(entry.target);
              steps.forEach(function (step, i) { step.classList.toggle('is-active', index === i); });
              arts.forEach(function (art, i) { art.classList.toggle('is-active', index === i); art.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
              story.dataset.storyActive = String(index);
            });
          }, { rootMargin: '-25% 0px -40% 0px', threshold: 0 });
          steps.forEach(function (step) { storyObserver.observe(step); });
          cleanup.push(function () { storyObserver.disconnect(); });
        }
      }
      var revealAnimations = [];
      if ('IntersectionObserver' in window) {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealObserver.unobserve(entry.target);
            if (!media.matches && entry.target.animate) revealAnimations.push(entry.target.animate([
              { opacity: .5, transform: 'translateY(28px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 850, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'none' }));
          });
        }, { threshold: .15 });
        root.querySelectorAll('[data-brand-reveal]').forEach(function (node) { revealObserver.observe(node); });
        cleanup.push(function () { revealObserver.disconnect(); revealAnimations.forEach(function (a) { a.cancel(); }); });
      }
      var track = root.querySelector('[data-product-track]');
      if (track) {
        var previous = root.querySelector('[data-product-previous]');
        var next = root.querySelector('[data-product-next]');
        var raf = null;
        function updateArrows() { previous.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }
        function move(direction) { var card = track.firstElementChild; if (!card) return; track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 28), behavior: media.matches ? 'instant' : 'smooth' }); }
        listen(previous, 'click', function () { move(-1); });
        listen(next, 'click', function () { move(1); });
        listen(track, 'oxp:products:updated', updateArrows);
        listen(track, 'scroll', function () { if (raf !== null) return; raf = requestAnimationFrame(function () { raf = null; updateArrows(); }); }, { passive: true });
        if ('ResizeObserver' in window) { var resizeObserver = new ResizeObserver(updateArrows); resizeObserver.observe(track); cleanup.push(function () { resizeObserver.disconnect(); }); }
        root.querySelector('[data-product-controls]').hidden = false;
        updateArrows();
        cleanup.push(function () { if (raf !== null) cancelAnimationFrame(raf); });
      }
      function changedPreference() {
        if (playback) playback.setReduced(media.matches);
        if (media.matches) { pans.forEach(function (a) { a.cancel(); }); pans.clear(); revealAnimations.forEach(function (a) { a.cancel(); }); }
        else if (playback) { pan(playback.getState().index); if (!playback.getState().running && pans.has(playback.getState().index)) pans.get(playback.getState().index).pause(); }
      }
      if (media.addEventListener) listen(media, 'change', changedPreference);
      root.dataset.brandReady = 'true';
      cleanups.set(root, function () { cleanup.forEach(function (fn) { fn(); }); cleanups.delete(root); });
    });
  }
  window.OpenXBrandMotion = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-brand-home]');
    if (root && cleanups.has(root)) cleanups.get(root)();
  });
})();
